import { useEffect } from "preact/hooks";

export default function ButtonTop() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const btn = document.getElementById("button-top-island");
    const link = document.getElementById("button-top");
    let target = document.getElementById("hero-header");

    if (!btn) return;

    if (!target) {
      target = document.querySelector("article div") 
    }

    let triggerDepth = window.innerHeight;
    let isVisible = false;
    let ticking = false;

    // Update visibility ONLY when state changes
    // Check if better way to do this
    const updateVisibility = (shouldBeVisible) => {
      if (shouldBeVisible !== isVisible) {
        isVisible = shouldBeVisible;
        if (shouldBeVisible) {
          btn.setAttribute("data-visible", "true");
        } else {
          btn.removeAttribute("data-visible");
        }
      }
    };

    // Throttle scroll events
    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          const shouldBeVisible = window.scrollY > triggerDepth;
          updateVisibility(shouldBeVisible);
          ticking = false;
        });
      }
    };

    // Update trigger depth on viewport resizw
    const handleResize = () => {
      triggerDepth = window.innerHeight;
    };

    // Handle click to scroll to top without changing URL hash
    const handleClick = (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize, { passive: true });
    
    if (link) {
      link.addEventListener("click", handleClick);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
      if (link) {
        link.removeEventListener("click", handleClick);
      }
    };
  }, []);

}